import { render, staticRenderFns } from "./ConfirmPresidentDirector.vue?vue&type=template&id=88c49f00&"
import script from "./ConfirmPresidentDirector.vue?vue&type=script&lang=js&"
export * from "./ConfirmPresidentDirector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports